import { render, staticRenderFns } from "./CurrentMastitisSituation.vue?vue&type=template&id=e174c320&"
import script from "./CurrentMastitisSituation.vue?vue&type=script&lang=js&"
export * from "./CurrentMastitisSituation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports